<div class="tile-image-workspace">
    <div class="image-toolbar">
        <p-selectbutton
            [options]="slots"
            [ngModel]="slot"
            (ngModelChange)="changeSlot($event)"
            [ngModelOptions]="{standalone: true}"
            [allowEmpty]="false"
            ariaLabel="Bildbereich"
            i18n-ariaLabel="@@tileImageSlot"
        ></p-selectbutton>
        <button
            pButton
            type="button"
            [text]="true"
            [disabled]="busy"
            aria-label="Icon auswählen"
            i18n-aria-label="@@tileImageSelectIcon"
            pTooltip="Icon auswählen"
            i18n-pTooltip="@@tileImageSelectIcon"
            (click)="iconClick.emit()"
        ><i
                class="ri-image-edit-line"
                aria-hidden="true"
            ></i></button>
        <button
            pButton
            type="button"
            [text]="true"
            [disabled]="busy || !currentImage"
            aria-label="Bild entfernen"
            i18n-aria-label="@@tileImageRemove"
            pTooltip="Bild entfernen"
            i18n-pTooltip="@@tileImageRemove"
            (click)="remove()"
        ><i
                class="ri-delete-bin-line"
                aria-hidden="true"
            ></i></button>
    </div>
    <label class="image-upload">
        <span i18n="@@tileImageUploadLarge">Bild hochladen (PNG, JPEG, WebP, GIF; max. 10 MB)</span>
        <input
            type="file"
            accept="image/png,image/jpeg,image/webp,image/gif"
            [disabled]="busy"
            (change)="upload($event)"
        >
    </label>
    @if (scope === 'global') {
    <label class="prompt-field">
        <span i18n="@@tileImagePrompt">Bild-Prompt</span>
        <textarea
            pTextarea
            rows="3"
            maxlength="2000"
            [(ngModel)]="prompt"
            [ngModelOptions]="{standalone: true}"
            [disabled]="busy"
        ></textarea>
    </label>
    <div class="image-toolbar">
        <button
            pButton
            type="button"
            [disabled]="busy || !capabilities?.available || !prompt.trim()"
            (click)="generate()"
        ><i
                class="ri-sparkling-line"
                aria-hidden="true"
            ></i><span i18n="@@tileImageGenerate">Mit fal.ai generieren</span></button>
        @if (busy) {
        <button
            pButton
            type="button"
            [outlined]="true"
            (click)="cancel()"
        ><i
                class="ri-stop-circle-line"
                aria-hidden="true"
            ></i><span i18n="@@tileImageCancel">Abbrechen</span></button>
        }
        <small class="image-note">{{prompt.length}} / 2000</small>
    </div>
    @if (capabilities?.available) {
    <small
        class="image-note"
        i18n="@@tileImageDisclosure"
    >Der Prompt wird an fal.ai gesendet. Generierungen sind kostenpflichtig; Abbrechen garantiert keinen Kostenstopp.
        Tageslimit: {{capabilities?.dailyLimit}}.</small>
    } @else {
    <small
        class="image-note"
        i18n="@@tileImageUnavailable"
    >fal.ai ist nicht verfügbar oder für dein Konto nicht freigeschaltet.</small>
    }
    }
    @if (busy) { <p
        role="status"
        class="image-note"
        i18n="@@tileImageWorking"
    >Bild wird erstellt und komprimiert …</p> }
    @if (error) { <p
        role="alert"
        class="text-danger"
    >{{error}}</p> }
    <div class="image-toolbar mode-toolbar">
        <span i18n="@@tileImageMode">Bilddarstellung</span>
        <p-selectbutton
            [options]="modes"
            [ngModel]="candidate?.imageMode || tile.imageMode || 'logo'"
            (ngModelChange)="changeMode($event)"
            [ngModelOptions]="{standalone: true}"
            [allowEmpty]="false"
            [disabled]="busy"
            ariaLabel="Bilddarstellung"
            i18n-ariaLabel="@@tileImageMode"
        ></p-selectbutton>
    </div>
    @if (candidate) {
    <section
        class="image-candidate"
        aria-label="Bildvorschlag"
        i18n-aria-label="@@tileImageProposal"
    >
        <strong i18n="@@tileImageProposal">Bildvorschlag</strong>
        <img
            class="candidate-image"
            [src]="candidateImage"
            alt="Bildvorschlag"
            i18n-alt="@@tileImageProposal"
        >
        <app-tile-preview
            [tile]="candidate"
            variant="compact"
        ></app-tile-preview>
        <small
            class="image-note"
            i18n="@@tileImageStorage"
        >Bilddaten insgesamt: {{storageKilobytes}} KB Base64, maximal 176 KB.</small>
        <div class="image-toolbar">
            <button
                pButton
                type="button"
                [disabled]="busy"
                (click)="adopt()"
            ><i
                    class="ri-check-line"
                    aria-hidden="true"
                ></i><span i18n="@@tileImageAdopt">In den Entwurf übernehmen</span></button>
            <button
                pButton
                type="button"
                [text]="true"
                [disabled]="busy"
                (click)="candidate = undefined"
            ><i
                    class="ri-close-line"
                    aria-hidden="true"
                ></i><span i18n="@@tileImageDiscard">Verwerfen</span></button>
        </div>
    </section>
    } @else {
    <app-tile-preview
        [tile]="tile"
        variant="compact"
        [editable]="!busy"
        (iconClick)="iconClick.emit()"
    ></app-tile-preview>
    }
</div>
